import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading label="Verificando acceso…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !["admin", "superadmin", "editor", "moderator"].includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
